export default "__VITE_ASSET__70dba10d__"